import React, { useEffect, useMemo, useState } from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { uniqueFacilityMemberIds } from "reduxSlices/adminFacilitySlice"
import { useSCIMResourceManagement } from "hooks"
import * as API from "services/api"
import DraggableUser from "./DraggableUser"

const UserSourceList = ({ className = "", nameFilter = "" }) => {
  const [users, setUsers] = useState([])

  const { departmentsManagedBySCIM } = useSCIMResourceManagement()
  const facilityMemberIds = useSelector(uniqueFacilityMemberIds, isEqual)

  useEffect(() => {
    const loadUsers = async () => {
      const response = await API.activityHubOrganizationUsers({ active: true })

      if (response.ok) {
        setUsers(response.data)
      }
    }

    loadUsers()
  }, [])

  const userList = useMemo(() => {
    if (!departmentsManagedBySCIM) return users

    return users.filter((user) => (
      facilityMemberIds.includes(user.id)
    ))
  }, [departmentsManagedBySCIM, facilityMemberIds, users])

  const filteredUsers = useMemo(() => {
    if (!nameFilter) return userList

    const matcher = new RegExp(nameFilter, "i")

    return userList.filter((user) => (
      matcher.test(user.fullName)
    ))
  }, [nameFilter, userList])

  return (
    <div className={className}>
      <ol>
        {
          filteredUsers.map((user) => (
            <li key={user.id} className="mb-4 last:mb-0">
              <DraggableUser user={user} />
            </li>
          ))
        }
      </ol>
    </div>
  )
}

UserSourceList.propTypes = {
  className: types.string,
  nameFilter: types.string,
}

export default UserSourceList
